import { Link } from 'react-router-dom';
import { STATUS_HINT, STATUS_LABEL, USERS } from '../lib/users.js';

/**
 * Demo "login" — three personas covering pre-register / pre-visit /
 * post-visit relationships to a D-COMPASS program. Click one to enter
 * the role-specific landing experience. NOT real authentication.
 *
 * 運営 (operator) is intentionally NOT in this list — it's a different
 * category of access, exposed via the topbar instead.
 */
export function UserList() {
  return (
    <div className="main">
      <div className="container">
        <h1>誰として体験しますか?</h1>
        <p className="lede">
          このプロトタイプは認証していません。役割を選んで、その人の状態に合わせた画面に進みます。
        </p>

        <div className="user-list">
          {USERS.map((u) => (
            <Link key={u.id} to={`/user/${u.id}`} className="user-card">
              <div className="avatar avatar-sm">{u.avatar_initial}</div>
              <div className="user-card-body">
                <div className="user-card-head">
                  <h2>{u.display_name}</h2>
                  <span className="user-status-tag">{STATUS_LABEL[u.status]}</span>
                </div>
                {u.affiliation && <p className="user-card-meta">{u.affiliation}</p>}
                <p className="user-card-bio">{u.bio}</p>
                <p className="user-card-hint">{STATUS_HINT[u.status]}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
